import type { IApiError, IApiSuccessMessageResponse } from '@/api/types';

export const generateErrorMessage = (error: IApiError) => {
  const defaultMessage = 'Произошла ошибка при отправке запроса';

  if (error.status === 403) {
    return 'У вас нет прав для данного действия';
  }

  if (error.status >= 500) {
    return defaultMessage;
  }

  return error?.data?.errors[0]?.message || defaultMessage;
};

export const generateSuccessMessage = (response: IApiSuccessMessageResponse, fallback: string) =>
  response?.data?.message || fallback;
